<template>
  <div>
    <div v-if="!loading" class="d-flex flex-column">
      <div v-if="success" class="mt-5 mb-5">
        <h1 class="ang-heading mb-5">Dziękujemy za uzupełnienie ankiety!</h1>
        <p class="ang-description pt-5 mt-4">
          Jeżeli <span v-if="gender === 'M'">chciałby Pan</span
          ><span v-else-if="gender">chciałaby Pani</span
          ><span v-else>chciałaby/chciałby Pani/Pan</span>
          dowiedzieć się więcej o nas i naszej społeczności, zapraszamy do
          odwiedzenia stron:
        </p>
        <a target="_blank" href="https://angfinanse.pl">angfinanse.pl</a><br />
        <a target="_blank" href="https://nno.pl">nno.pl</a><br />
      </div>
      <div v-else class="mt-5">
        <h2 class="ang-heading mb-5" v-if="gender === 'M'">
          Zależy nam na Pana opinii!
        </h2>
        <h2 class="ang-heading mb-5" v-else-if="gender">
          Zależy nam na Pani opinii!
        </h2>
        <h2 class="ang-heading mb-5" v-else>Zależy nam na Twojej opinii!</h2>
      </div>
      <div v-if="!success" class="ang-survey ang-card">
        <p class="ang-survey__info">
          Jak ocenia <span v-if="gender === 'M'">Pan</span
          ><span v-else-if="gender">Pani</span
          ><span v-else>Pani/Pan</span> współpracę z ekspertem ANG:
        </p>
        <form
          class="ang-card-body"
          id="clientResearchForm"
          method="post"
          :action="action"
        >
          <label class="ang-survey__question"
            >1. Przedstawienie ofert odpowiadających na
            <span v-if="gender === 'M'">Pana</span
            ><span v-else-if="gender">Pani</span
            ><span v-else>Pani/Pana</span> potrzeby.</label
          >
          <ul class="ang-survey__raiting">
            <li>
              <input
                type="radio"
                :required="true"
                name="response[B][rating]"
                id="responseB1"
                v-model="responses['B']"
                value="1"
              />
              <span class="checkmark"></span>
              <label for="responseB1" class="pointerable">bardzo źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[B][rating]"
                id="responseB2"
                v-model="responses['B']"
                value="2"
              />
              <span class="checkmark"></span>
              <label for="responseB2" class="pointerable">źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[B][rating]"
                id="responseB3"
                v-model="responses['B']"
                value="3"
              />
              <span class="checkmark"></span>
              <label for="responseB3" class="pointerable neutral"
                >neutralnie</label
              >
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[B][rating]"
                id="responseB4"
                v-model="responses['B']"
                value="4"
              />
              <span class="checkmark"></span>
              <label for="responseB4" class="pointerable">dobrze</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[B][rating]"
                id="responseB5"
                v-model="responses['B']"
                value="5"
              />
              <span class="checkmark"></span>
              <label for="responseB5" class="pointerable">bardzo dobrze</label>
            </li>
          </ul>
          <div
            class="ang-survey__substantiation"
            v-if="responses['B'] && responses['B'] < 3"
          >
            <label class="ang-form-label"
              >Prosimy o krótkie uzasadnienie odpowiedzi:</label
            >
            <input
              type="text"
              class="ang-form-control"
              name="response[B][comment]"
            />
          </div>
          <label class="ang-survey__question"
            >2. Zrozumiałe przedstawienie ofert z uwzględnieniem
            <span v-if="[4, 5].indexOf(type) < 0"
              >wszystkich kosztów związanych z uzyskaniem finansowania.</span
            ><span v-else-if="[4, 5].indexOf(type) >= 0"
              >zakresu oraz warunków ubezpieczenia.</span
            ></label
          >
          <ul class="ang-survey__raiting">
            <li>
              <input
                type="radio"
                :required="true"
                name="response[A][rating]"
                id="responseA1"
                v-model="responses['A']"
                value="1"
              />
              <span class="checkmark"></span>
              <label for="responseA1" class="pointerable">bardzo źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[A][rating]"
                id="responseA2"
                v-model="responses['A']"
                value="2"
              />
              <span class="checkmark"></span>
              <label for="responseA2" class="pointerable">źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[A][rating]"
                id="responseA3"
                v-model="responses['A']"
                value="3"
              />
              <span class="checkmark"></span>
              <label for="responseA3" class="pointerable neutral"
                >neutralnie</label
              >
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[A][rating]"
                id="responseA4"
                v-model="responses['A']"
                value="4"
              />
              <span class="checkmark"></span>
              <label for="responseA4" class="pointerable">dobrze</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[A][rating]"
                id="responseA5"
                v-model="responses['A']"
                value="5"
              />
              <span class="checkmark"></span>
              <label for="responseA5" class="pointerable">bardzo dobrze</label>
            </li>
          </ul>
          <div
            class="ang-survey__substantiation"
            v-if="responses['A'] && responses['A'] < 3"
          >
            <label class="ang-form-label"
              >Prosimy o krótkie uzasadnienie odpowiedzi:</label
            >
            <input
              type="text"
              class="ang-form-control"
              name="response[A][comment]"
            />
          </div>
          <label v-if="[4, 5].indexOf(type) < 0" class="ang-survey__question"
            >3. Pomoc w kompletowaniu dokumentacji do wniosku kredytowego i jego
            uzupełnieniu.</label
          >
          <label
            v-else-if="[4, 5].indexOf(type) >= 0"
            class="ang-survey__question"
            >3. Pomoc i wyjaśnienie zasad działania ubezpieczenia oraz sposób
            jego zawarcia.</label
          >
          <ul class="ang-survey__raiting">
            <li>
              <input
                type="radio"
                :required="true"
                name="response[C][rating]"
                id="responseC1"
                v-model="responses['C']"
                value="1"
              />
              <span class="checkmark"></span>
              <label for="responseC1" class="pointerable">bardzo źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[C][rating]"
                id="responseC2"
                v-model="responses['C']"
                value="2"
              />
              <span class="checkmark"></span>
              <label for="responseC2" class="pointerable">źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[C][rating]"
                id="responseC3"
                v-model="responses['C']"
                value="3"
              />
              <span class="checkmark"></span>
              <label for="responseC3" class="pointerable neutral"
                >neutralnie</label
              >
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[C][rating]"
                id="responseC4"
                v-model="responses['C']"
                value="4"
              />
              <span class="checkmark"></span>
              <label for="responseC4" class="pointerable">dobrze</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[C][rating]"
                id="responseC5"
                v-model="responses['C']"
                value="5"
              />
              <span class="checkmark"></span>
              <label for="responseC5" class="pointerable">bardzo dobrze</label>
            </li>
          </ul>
          <div
            class="ang-survey__substantiation"
            v-if="responses['C'] && responses['C'] < 3"
          >
            <label class="ang-form-label"
              >Prosimy o krótkie uzasadnienie odpowiedzi:</label
            >
            <input
              type="text"
              class="ang-form-control"
              name="response[C][comment]"
            />
          </div>
          <div v-if="[4, 5].indexOf(type) < 0">
            <label class="ang-survey__question"
              >4. Informowanie na bieżąco o postępach w procesie uzyskiwania
              kredytu.</label
            >
            <ul class="ang-survey__raiting">
              <li>
                <input
                  type="radio"
                  :required="true"
                  name="response[D][rating]"
                  id="responseD1"
                  v-model="responses['D']"
                  value="1"
                />
                <span class="checkmark"></span>
                <label for="responseD1" class="pointerable">bardzo źle</label>
              </li>
              <li>
                <input
                  type="radio"
                  :required="true"
                  name="response[D][rating]"
                  id="responseD2"
                  v-model="responses['D']"
                  value="2"
                />
                <span class="checkmark"></span>
                <label for="responseD2" class="pointerable">źle</label>
              </li>
              <li>
                <input
                  type="radio"
                  :required="true"
                  name="response[D][rating]"
                  id="responseD3"
                  v-model="responses['D']"
                  value="3"
                />
                <span class="checkmark"></span>
                <label for="responseD3" class="pointerable neutral"
                  >neutralnie</label
                >
              </li>
              <li>
                <input
                  type="radio"
                  :required="true"
                  name="response[D][rating]"
                  id="responseD4"
                  v-model="responses['D']"
                  value="4"
                />
                <span class="checkmark"></span>
                <label for="responseD4" class="pointerable">dobrze</label>
              </li>
              <li>
                <input
                  type="radio"
                  :required="true"
                  name="response[D][rating]"
                  id="responseD5"
                  v-model="responses['D']"
                  value="5"
                />
                <span class="checkmark"></span>
                <label for="responseD5" class="pointerable"
                  >bardzo dobrze</label
                >
              </li>
            </ul>
            <div
              class="ang-survey__substantiation"
              v-if="responses['D'] && responses['D'] < 3"
            >
              <label class="ang-form-label"
                >Prosimy o krótkie uzasadnienie odpowiedzi:</label
              >
              <input
                type="text"
                class="ang-form-control"
                name="response[D][comment]"
              />
            </div>
          </div>
          <label class="ang-survey__question"
            ><span v-if="[4, 5].indexOf(type) < 0">5.</span
            ><span v-else-if="[4, 5].indexOf(type) >= 0">4.</span>Profesjonalizm
            eksperta.</label
          >
          <ul class="ang-survey__raiting">
            <li>
              <input
                type="radio"
                :required="true"
                name="response[E][rating]"
                id="responseE1"
                v-model="responses['E']"
                value="1"
              />
              <span class="checkmark"></span>
              <label for="responseE1" class="pointerable">bardzo źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[E][rating]"
                id="responseE2"
                v-model="responses['E']"
                value="2"
              />
              <span class="checkmark"></span>
              <label for="responseE2" class="pointerable">źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[E][rating]"
                id="responseE3"
                v-model="responses['E']"
                value="3"
              />
              <span class="checkmark"></span>
              <label for="responseE3" class="pointerable neutral"
                >neutralnie</label
              >
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[E][rating]"
                id="responseE4"
                v-model="responses['E']"
                value="4"
              />
              <span class="checkmark"></span>
              <label for="responseE4" class="pointerable">dobrze</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[E][rating]"
                id="responseE5"
                v-model="responses['E']"
                value="5"
              />
              <span class="checkmark"></span>
              <label for="responseE5" class="pointerable">bardzo dobrze</label>
            </li>
          </ul>
          <div
            class="ang-survey__substantiation"
            v-if="responses['E'] && responses['E'] < 3"
          >
            <label class="ang-form-label"
              >Prosimy o krótkie uzasadnienie odpowiedzi:</label
            >
            <input
              type="text"
              class="ang-form-control"
              name="response[E][comment]"
            />
          </div>
          <label class="ang-survey__question"
            ><span v-if="[4, 5].indexOf(type) < 0">6.</span
            ><span v-else-if="[4, 5].indexOf(type) >= 0">5.</span> Atmosfera
            współpracy, szacunek do <span v-if="gender === 'M'">Pana</span
            ><span v-else-if="gender">Pani</span><span v-else>Pani/Pana</span> i
            kultura osobista eksperta.</label
          >
          <ul class="ang-survey__raiting">
            <li>
              <input
                type="radio"
                :required="true"
                name="response[F][rating]"
                id="responseF1"
                v-model="responses['F']"
                value="1"
              />
              <span class="checkmark"></span>
              <label for="responseF1" class="pointerable">bardzo źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[F][rating]"
                id="responseF2"
                v-model="responses['F']"
                value="2"
              />
              <span class="checkmark"></span>
              <label for="responseF2" class="pointerable">źle</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[F][rating]"
                id="responseF3"
                v-model="responses['F']"
                value="3"
              />
              <span class="checkmark"></span>
              <label for="responseF3" class="pointerable neutral"
                >neutralnie</label
              >
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[F][rating]"
                id="responseF4"
                v-model="responses['F']"
                value="4"
              />
              <span class="checkmark"></span>
              <label for="responseF4" class="pointerable">dobrze</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[F][rating]"
                id="responseF5"
                v-model="responses['F']"
                value="5"
              />
              <span class="checkmark"></span>
              <label for="responseF5" class="pointerable">bardzo dobrze</label>
            </li>
          </ul>
          <div
            class="ang-survey__substantiation"
            v-if="responses['F'] && responses['F'] < 3"
          >
            <label class="ang-form-label"
              >Prosimy o krótkie uzasadnienie odpowiedzi:</label
            >
            <input
              type="text"
              class="ang-form-control"
              name="response[F][comment]"
            />
          </div>
          <label v-if="[4, 5].indexOf(type) < 0" class="ang-survey__question"
            >7. Czy ekspert upewnił się, że posiada
            <span v-if="gender === 'M'">Pan</span
            ><span v-else-if="gender">Pani</span
            ><span v-else>Pan/Pani</span> pełną wiedzę o produkcie, w tym
            ryzykach z nim związanych?</label
          >
          <label
            v-else-if="[4, 5].indexOf(type) >= 0"
            class="ang-survey__question"
            >6. Czy ekspert upewnił się, że posiada
            <span v-if="gender === 'M'">Pan</span
            ><span v-else-if="gender">Pani</span
            ><span v-else>Pan/Pani</span> pełną wiedzę o polisie?</label
          >
          <div
            class="ang-survey__substantiation ang-survey__substantiation-yes-no"
          >
            <span class="mr-2">TAK</span>
            <div class="ang-survey__substantiation-container">
              <div class="ang-survey__states-control">
                <input
                  type="radio"
                  id="responseG1"
                  name="response[G][rating]"
                  class="option1"
                  v-model="responses['G']"
                  value="tak"
                  required
                />
                <input
                  type="radio"
                  id="responseG2"
                  name="response[G][rating]"
                  class="option2"
                  v-model="responses['G']"
                  value="brakOpdowiedzi"
                  :checked="gender === null"
                  required
                />
                <input
                  type="radio"
                  id="responseG3"
                  name="response[G][rating]"
                  class="option3"
                  v-model="responses['G']"
                  value="nie"
                  required
                />
                <div class="ang-survey__states-control-labels">
                  <label class="option1" for="responseG1"></label>
                  <label class="option2" for="responseG2"></label>
                  <label class="option3" for="responseG3"></label>
                </div>
              </div>
            </div>
            <span class="ml-2">NIE</span>
          </div>
          <div class="mb-4" v-if="[4, 5].indexOf(type) < 0">
            <label class="ang-survey__question"
              >8. Ile różnych ofert (produktów) bankowych zostało
              <span v-if="gender === 'M'">Panu</span
              ><span v-else-if="gender">Pani</span
              ><span v-else>Pani/Panu</span> zaproponowanych?</label
            >
            <div class="ang-survey__rating-offer">
              <div class="ang-survey__rating-offer-item">
                <input
                  :required="true"
                  type="radio"
                  id="oneOffer"
                  name="response[H]"
                  value="1"
                />
                <span class="checkmark"></span>
                <label class="full" for="oneOffer">1</label>
              </div>
              <div class="ang-survey__rating-offer-item">
                <input
                  :required="true"
                  type="radio"
                  id="twoOffer"
                  name="response[H]"
                  value="2"
                />
                <span class="checkmark"></span>
                <label class="half" for="twoOffer">2</label>
              </div>
              <div class="ang-survey__rating-offer-item">
                <input
                  :required="true"
                  type="radio"
                  id="threeOffer"
                  name="response[H]"
                  value="3"
                />
                <span class="checkmark"></span>
                <label class="full" for="threeOffer">3</label>
              </div>
              <div class="ang-survey__rating-offer-item">
                <input
                  :required="true"
                  type="radio"
                  id="more"
                  name="response[H]"
                  value="more"
                />
                <span class="checkmark"></span>
                <label class="full" for="more">więcej</label>
              </div>
            </div>
          </div>
          <label class="ang-survey__question">
            <span v-if="[4, 5].indexOf(type) >= 0">7.</span>
            <span v-else>9.</span>
            Czy <span v-if="gender === 'M'">poleciłby Pan</span
            ><span v-else-if="gender">poleciłaby Pani</span
            ><span v-else>polecił(a)by Pani/Pan</span> swoim znajomym usługi
            tego eksperta ANG?<br />
          </label>
          <p class="ang-survey__raiting-description">
            <span>0 - zdecydowanie nie polecę</span>
            <span class="ang-survey__raiting-description-right">
              10 - zdecydowanie polecę</span
            >
          </p>
          <ul class="ang-survey__raiting-long">
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI0"
                v-model="responses['I']"
                value="0"
              />
              <span class="checkmark"></span>
              <label for="responseI1" class="pointerable">0</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI1"
                v-model="responses['I']"
                value="1"
              />
              <span class="checkmark"></span>
              <label for="responseI1" class="pointerable">1</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI2"
                v-model="responses['I']"
                value="2"
              />
              <span class="checkmark"></span>
              <label for="responseI2" class="pointerable">2</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI3"
                v-model="responses['I']"
                value="3"
              />
              <span class="checkmark"></span>
              <label for="responseI3" class="pointerable neutral">3</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI4"
                v-model="responses['I']"
                value="4"
              />
              <span class="checkmark"></span>
              <label for="responseI4" class="pointerable">4</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI5"
                v-model="responses['I']"
                value="5"
              />
              <span class="checkmark"></span>
              <label for="responseI5" class="pointerable">5</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI6"
                v-model="responses['I']"
                value="6"
              />
              <span class="checkmark"></span>
              <label for="responseI6" class="pointerable">6</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI7"
                v-model="responses['I']"
                value="7"
              />
              <span class="checkmark"></span>
              <label for="responseI7" class="pointerable">7</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI8"
                v-model="responses['I']"
                value="8"
              />
              <span class="checkmark"></span>
              <label for="responseI8" class="pointerable">8</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI9"
                v-model="responses['I']"
                value="9"
              />
              <span class="checkmark"></span>
              <label for="responseI9" class="pointerable">9</label>
            </li>
            <li>
              <input
                type="radio"
                :required="true"
                name="response[I][rating]"
                id="responseI10"
                v-model="responses['I']"
                value="10"
              />
              <span class="checkmark"></span>
              <label for="responseI10" class="pointerable">10</label>
            </li>
          </ul>
          <div
            class="ang-survey__substantiation"
            v-if="responses['I'] && responses['I'] >= 0"
          >
            <label class="ang-form-label"
              >Prosimy o krótkie uzasadnienie odpowiedzi:</label
            >
            <input
              type="text"
              class="ang-form-control"
              name="response[I][comment]"
            />
          </div>
          <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
            <h5 class="ang-card-title">Wystąpił błąd!</h5>
            <label class="form-error error">{{ error }}</label>
          </div>
          <div class="text-right" v-if="!success">
            <spinner v-if="sending"></spinner>
            <button
              type="submit"
              class="btn btn-lg ang-btn-lg ang-button mt-1"
              v-if="!sending"
            >
              Wyślij
            </button>
          </div>
        </form>
        <div class="deco-2">
          <div class="parallax-scene">
            <svg
              width="291"
              height="301"
              class="parallax-move"
              data-depth="0.4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 290.8 301.08"
            >
              <path
                d="M181.24 268.83c-31.74-6.2-50.08 15.86-62.26 7.02-11.8-8.57 3.2-30.91-9.95-48.42-12.47-16.6-33.28-6.33-53.6-20.08-27.6-18.68-39.29-71.48-20.51-94.07 24.06-28.93 89.26 2.43 106.9-26.45 9.81-16.07-6.37-32.26 3.89-45.48 17.77-22.9 93.16-8.8 102.43 21.79 7.87 26-38.3 43.14-34.86 82.29 3.09 35.18 42.11 41.11 41.82 75.45-.23 27.1-24.82 55.31-46.76 56.6-10.66.64-11.66-5.63-27.1-8.65z"
                fill="#FFD433"
              ></path>
            </svg>
          </div>
        </div>
        <div class="deco-4">
          <div class="parallax-scene">
            <svg
              class="parallax-move"
              data-depth="0.4"
              height="226.12"
              viewBox="0 0 222.922 226.12"
              width="222.922"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M152.318 155.231c-8.283 6.18-21.242 2.146-37.635-3.187-25.472-8.286-23.941-14.048-35.653-14.508-20.199-.793-26.436 16.274-46.978 13.665-2.8-.356-15.594-1.979-20.159-10.578-7.85-14.792 11.33-45.223 36.242-55.391 12.282-5.014 23.97-4.294 44.123-3.05 27.015 1.667 35.371 7.761 46.188 1.495 13.407-7.766 9.779-22.462 20.207-26.726 19.37-7.923 60.748 30.97 54.278 48.263-5.292 14.117-39.544 5.884-51.77 28.451-5.162 9.53-2.022 16.48-8.843 21.566z"
                fill="#11A68A"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="height: 300px">
      <spinner position="center"></spinner>
    </div>
  </div>
</template>

<script>
import spinner from "@/components/partials/misc/spinner";
import api from "@/services/api";
import ajax from "@/services/ajax";
import $ from "jquery";

export default {
  data() {
    return {
      uid: null,
      responses: {},
      error: null,
      gender: null,
      type: null,
      sending: false,
      loading: true,
      success: false,
    };
  },
  components: { spinner },
  computed: {
    action() {
      return "/research/" + this.uid;
    },
  },
  mounted() {
    let self = this;
    if (typeof this.$route.params.uid !== "undefined") {
      this.uid = this.$route.params.uid;
    } else {
      window.location.href = "https://angspoldzielnia.pl";
    }

    if (this.uid) {
      api.get(
        "/research/" + self.uid,
        {},
        function (data) {
          self.loading = false;
          self.gender = data.gender;
          self.type = data.type;
          console.log("type = " + data.type);
          self.$nextTick(function () {
            // $("#responseG2").prop("checked", true)
            ajax.postValidate(
              $("#clientResearchForm"),
              self,
              function () {
                self.success = true;
                self.sending = false;
              },
              function (data) {
                console.log(data);
                self.error = data.message;
                self.sending = false;
                $("html,body").animate(
                  { scrollTop: $(document).height() },
                  "slow"
                );
              },
              function () {
                self.error = null;
                self.sending = true;
              }
            );
          });
        },
        function () {
          window.location.href = "https://angspoldzielnia.pl";
        }
      );
    }
  },
  name: "CustomerResearch",
};
</script>
